var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-logo"},[_c('AppImage',{staticClass:"menu-logo__image",attrs:{"src":_vm.logoImageUrl,"contain":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }